import React, { useState } from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Paper from '@material-ui/core/Paper';
import { Query } from 'react-apollo';
import { GET_ALL_STUDENT_ROOMS,  GET_ROOMS_BY_STUDENT_COACHES} from 'graphql/chat';
import Spin from 'components/common/Spin';
import Room from './Room';
import { useSelector } from 'react-redux';

const ROOMS_LABEL = {
  coaches: 'Counseling Team',
  admin: 'Admin',
  parents_coaches: 'Parent & Coaches',
  parents_admin: 'Parent & Admin',
};

const ChatHistory = ({
  match: {
    params: { id },
  },
}) => {
  const [tab, setTab] = useState(0);
  const user = useSelector((state) => state.user.user);

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };
  return (
    <div>
      <Query query={user.type === 'admin' ? GET_ALL_STUDENT_ROOMS : GET_ROOMS_BY_STUDENT_COACHES} variables={{ userId: id }}>
        {({ data, loading }) => {
          if (loading) return <Spin spinning />;
          const { rooms, chat_rooms } = data;

          return (
            <>
              <Paper>
                <Tabs
                  indicatorColor="primary"
                  textColor="primary"
                  value={tab}
                  onChange={handleTabChange}
                >
                  {user.type === 'admin'
                    ? chat_rooms.map((r) => (
                        <Tab key={r.id} label={ROOMS_LABEL[r.room_name]} />
                      ))
                    : rooms.map((r) => (
                        <Tab key={r.id} label={'Counseling Team'} />
                      ))}
                </Tabs>
                <Room room={rooms ? rooms[tab] : chat_rooms[tab]} />
              </Paper>
            </>
          );
        }}
      </Query>
    </div>
  );
};

export default ChatHistory;
